export const CALENDAR_VIEW_TYPES = {
  daily: 'daily',
  monthly: 'monthly',
};
